import React,{useState,useEffect} from 'react';
import { Router, Location, Redirect,Link,useNavigate } from 'react-router-dom';
import Chart from "react-apexcharts";
import { createGlobalStyle } from 'styled-components';
import { DOCUMENT_LIST } from '../../prefixed/documents';
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from '../../constants';
import {stringToHex} from "../forms/validator";
import axios from 'axios';


const JComponent= ({modalObject}) => {
  const navigate=useNavigate();
  const [rows,setRows]=useState([]);
  const [summaryRows,setSummaryRows]=useState([]);
  const [role,setRole]=useState("");
  useEffect(()=>{
	  if(localStorage.getItem("_xoxre")==="9999"){
		  setRole("9999");
	  }
  },[])  
  useEffect(()=>{
	loadSummaryList();
  },[]);
  const getValue=(_inArray,_key,_filter,_returnKey)=>{
	
	for(let i=0;i<_inArray.length;i++){
		const data=_inArray[i];
		if(data.id===_key && data.wStatus===_filter){
			return(isNaN(data[_returnKey])?0:data[_returnKey]);
		}
	}
	return(0);
  }
  const getWPCount=(_inArray,_implId)=>{
	for(let i=0;i<_inArray.length;i++){
		const data=_inArray[i];
		if(data.implAgency==_implId) return(data.wpcount);
	}
	return("0");
  }
  const loadSummaryList=async()=>{
	let _Response=await axios.post(API_CORE_SERVER+"/api/get_impl_agency.php");
	let _List=[];
	if(_Response.status===200){
		let _Data=_Response.data;
		_List=_Data;
	}
	let _rows=[];
	let _d={
		token:localStorage.getItem("_xoxex"),
		email:localStorage.getItem("_xoxem"),
	};
	let idata=stringToHex(JSON.stringify(_d));
	let wpimplList=[];

	try{
		const ires=await axios({
			method: 'post',
			url: API_CORE_SERVER+"/api/document/get-wprogress-groupby-implagency.php",
			headers: { 
				'Content-Type': 'application/x-www-form-urlencoded',
				//'Content-Type': 'application/json', 
			},
			data:"i="+idata
		  });
		  if(ires.status==200 && ires.data.status==1){
			wpimplList=ires.data.data;
			
		  }
		}catch(ier){}

	var config = {
		method: 'post',
		url: API_CORE_SERVER+"/api/document/get-documents-groupby-implagency.php",
		headers: { 
			'Content-Type': 'application/x-www-form-urlencoded',
			//'Content-Type': 'application/json', 
		},
		data:"i="+idata
	  };
	axios(config)
		.then((response)=>{
			if(response.status===200 && response.data){
				let data=response.data;
				if(data.status===1 && data.data && data.data.length>0){
					let records=data.data;
					for(let i=0;i<_List.length;i++){
					   let _Id=_List[i].implAgencyId;
					   
					  _rows.push({
						id:_Id,
						primaryName:_List[i].implAgencyName,
						ongoingProjects:getValue(records,_Id,"Ongoing","pCount"),
						ongoingCost:(getValue(records,_Id,"Ongoing","agrCost")/100000).toFixed(2),
						ongoingPerformance:getValue(records,_Id,"Ongoing","performance"),
						completedProjects:getValue(records,_Id,"Completed","pCount"),
						completedCost:(getValue(records,_Id,"Completed","agrCost")/100000).toFixed(2),
						completedPerformance:getValue(records,_Id,"Completed","performance"),
						wpcount:getWPCount(wpimplList, _Id),
						pCount:0
					  });
					} // loop
					setSummaryRows(_rows);
					
				}
				
			}
			
		}).catch((er)=>{
			console.log(er);
		})
  }

return(
	<>
	<div className='row'>
		<div className='col-md-12 p-4'>
		<h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-boxes'></i>Implementing Agency Report</h5>
			<div className='card'>
				<div className='card-body'>
					<table className='table mt-4 fs85rem'>
						<thead>
							<tr style={{fontSize:'14px',color:'#404040'}}>
								<td>Implementing Agency</td>
								<td colspan="4" align='center'>Ongoing Project/Asset</td>
								<td colspan="3" align='center'>Completed Project/Asset</td>
							</tr>
							<tr style={{fontSize:'14px',color:'#808080'}}>
								<td></td>
								<td align='center'>Count</td>
								<td align='center'>Agreement<br/> Cost (Lac)</td>
								<td align='center'>Updated Projects</td>
								<td align='center'>Performance%</td>

								<td align='center'>Count</td>
								<td align='center'>Agreement<br/> Cost (Lac)</td>
								<td align='center'>Performance%</td>
							</tr>
						</thead>
						<tbody>
					{
						summaryRows && summaryRows.length>0 ?
						<> 
							{
								summaryRows.map((item,index)=>{
									return(
												(item.ongoingProjects!=0 || item.completedProjects!=0)?
												<tr>
													<td>{item.primaryName}</td>
													<td align='center'>
														<div className='bg-primary rounded-pill text-white cursor-pointer'
														onClick={e=>{
															navigate(URLPREFIX+"/list/document/implementing-agency-vba",{state:{requestFor:"implementing-agency-comleted-view-by-admin",id:item.id,wstatus:"Ongoing",name:item.primaryName}})	
														}}
														>
															{item.ongoingProjects}
														</div>
													</td>
													<td align='center'>{item.ongoingCost}</td>
													<td align='center' ><span className="fw-bold px-4">{item.wpcount==0?"-":item.wpcount}</span></td>
													<td align='center'>{Number(item.ongoingPerformance).toFixed(3)}</td>
													<td align='center'>
														<div className='bg-success rounded-pill text-white cursor-pointer'
															onClick={e=>{
																navigate(URLPREFIX+"/list/document/implementing-agency-vba",{state:{requestFor:"implementing-agency-comleted-view-by-admin",id:item.id,wstatus:"Completed",name:item.primaryName}})	
															}}
														>
															{item.completedProjects}
														</div>	
													</td>
													<td align='center'>{item.completedCost}</td>
													<td align='center'>{Number(item.completedPerformance).toFixed(3)}</td>
												</tr>
												:null
												
									);	
								})
							}
						</>
						:<></>
					}
					</tbody>
					</table>
				</div>
			</div>
			
		</div>
		
	</div>
	</>

);
};
export default JComponent;